<template>
<drop-down icon="nc-icon nc-bell-55" tag="li" position="right" direction="none" class="nav-item btn-rotate dropdown ticket-notification">
  <a slot="title" slot-scope="{isOpen}" class="nav-link dropdown-toggle ticket-notification__trigger" data-toggle="dropdown" aria-haspopup="true" aria-label="Notifications" title="Notifications" :aria-expanded="isOpen" @click="openNotification()">
    <el-badge :value="unreadNotifications" class="item" :hidden="!unreadNotifications">
      <i class="nc-icon nc-bell-55"></i>
    </el-badge>
    <span class="ticket-notification__trigger-label">Notifications</span>
    <i class="nc-icon nc-minimal-down ticket-notification__chevron" aria-hidden="true"></i>
  </a>
  <li class="ticket-notification__head" @click.stop>
    <div>
      <span class="ticket-notification__eyebrow">INBOX</span>
      <strong>Notifications</strong>
    </div>
    <span class="ticket-notification__count" v-if="unreadNotifications">{{ unreadNotifications }} unread in latest 10</span>
    <span class="ticket-notification__count" v-else>{{ notifications.length }} recent</span>
  </li>
  <a class="dropdown-item ticket-notification__entry" v-for="notification in notifications" :key="notification.id" @click="goTo(notification)" :class="notification.seen ? 'seen':'unseen'">
    <div class="ticket-notification__title">{{ notification.title }}</div>
    <div class="ticket-notification__body">{{ notification.body }}</div>
    <div class="ticket-notification__time">{{ getTime(notification.timestamp) }}</div>
  </a>

  <a class="dropdown-item ticket-notification__clear" href="#" v-if="notifications.length">
    <el-button type="text" @click="clearNotifications()">Clear all</el-button>
  </a>

  <a class="dropdown-item ticket-notification__empty" href="#" v-if="!notifications.length">
    <span class="ticket-notification__empty-icon"><i class="nc-icon nc-bell-55"></i></span>
    <span>
      <strong>No notifications at the moment</strong>
      <small>New updates will appear here.</small>
    </span>
  </a>
</drop-down>
</template>

<script>
import {
  mapState
} from 'vuex';
import firebase from 'firebase/compat/app'
import 'firebase/compat/messaging'
import {
  User
} from '@/resources/user'
import {
  db
} from '@/firebase'
import { Authenticate } from '@/resources/authenticate'

export default {
  mounted() {
    if (performance.navigation.type === 1) {
      console.log("Page was reloaded");
      this.getUser()
      // You can execute your logic here when the page is reloaded
    }
  },
  computed: {
    ...mapState(['user'])
  },
  data() {
    return {
      unreadNotifications: 0,
      notifications: [],
      doneInitFirebase: false,
      notificationListeners: [],
      notificationsSubscribed: false,
      unsubscribeForegroundMessage: null
    }
  },
  beforeDestroy() {
    this.clearNotificationListeners()
    if (this.unsubscribeForegroundMessage) {
      this.unsubscribeForegroundMessage()
      this.unsubscribeForegroundMessage = null
    }
  },
  created: function () {
    if (!this.doneInitFirebase) {
      this.initialiazeFirebase()
    }
    this.getNotifications()
  },
  methods: {
    listenToNotifications(ref, event, callback) {
      ref.on(event, callback)
      this.notificationListeners.push({ ref, event, callback })
    },
    clearNotificationListeners() {
      this.notificationListeners.forEach(({ ref, event, callback }) => {
        ref.off(event, callback)
      })
      this.notificationListeners = []
    },
    goTo(notification) {
      let ref = db.ref('notifications/' + this.user.name + '/' + notification.id)
      notification.seen = true
      this.unreadNotifications = this.notifications.filter(item => !item.seen).length

      if (!notification.link) notification.link = ''
      ref.set(notification)

      if (notification.link && notification.link !== this.$route.path) {
        this.$router.push(notification.link)
      }
    },
    openNotification() {
      this.unreadNotifications = 0
    },
    initialiazeFirebase() {
      let self = this
      const messaging = firebase.messaging()
      let firebaseKeyPair = 'BNwGstyXI9sMJKU4jd2S60cjgQMcQJIDMnWTjV5mXDMq5oCl-bCsA8EkJ2uEewQdu_CZkueC-yxNwzkzyU3opDs'

      messaging.getToken({
        vapidKey: firebaseKeyPair
      }).then((currentToken) => {
        if (currentToken) {
          self.updateUserFcm(currentToken)
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      }).finally(() => {
        this.doneInitFirebase = true
      });

      this.unsubscribeForegroundMessage = messaging.onMessage(function (payload) {
        console.log('Receiving foreground message');
        // self.showNotification(payload.notification, payload.data)
      });

    },
    showNotification(notification, data) {
      this.$notify({
        type: 'success',
        title: notification.title,
        text: notification.body,
      });
    },
    getNotifications() {
      var self = this
      if (!this.user || this.notificationsSubscribed) return false
      this.notificationsSubscribed = true
      let path = 'notifications/' + this.user.name

      var ref = db.ref(path)
      const recentNotificationsRef = ref
        .orderByChild('timestamp')
        .limitToLast(10)

      this.listenToNotifications(recentNotificationsRef, "value", (snapshot) => {
        const data = snapshot.val() || {}
        self.notifications = Object.keys(data)
          .map(id => self.notificationFromFirebase(id, data[id]))
          .sort((a, b) => b.timestamp - a.timestamp)
        self.unreadNotifications = self.notifications.filter(notification => !notification.seen).length
      })

      const latestNotificationRef = ref
        .orderByChild('timestamp')
        .limitToLast(1)
      this.listenToNotifications(latestNotificationRef, "child_added", (snapshot) => {
        const notification = snapshot.val();
        if (!notification || !notification.timestamp) return
        var notificationDate = new Date(notification.timestamp * 1000)
        var currentDate = new Date()
        const differenceSec = Math.abs(currentDate - notificationDate) / 1000;
        console.log("New notification")
        if (differenceSec < 3) this.showNotification(notification)
      })
    },
    notificationFromFirebase(id, notification) {
      return {
        id: id,
        user_name: notification.user_name,
        title: notification.title,
        body: notification.body,
        link: notification.link,
        timestamp: notification.timestamp,
        seen: Boolean(notification.seen)
      }
    },
    getTime(timestamp) {
      return this.$moment.unix(timestamp).fromNow()
    },
    clearNotifications() {
      let ref = db.ref('notifications/' + this.user.name)
      ref.remove();
    },
    updateUserFcm(token) {
      console.log("FCM TOKEN " + token)
      User.updateFcm({
          device_key: token
        })
        .then(result => {})
        .catch(() => {})
    },
    getUser() {
      Authenticate.getUser(function (result) {
      })
    }
  }
}
</script>

<style>
.ticket-notification {
  position: relative;
  margin: 0;
}

.ticket-notification__trigger.nav-link {
  display: flex;
  min-width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  place-items: center;
  padding: 0 12px !important;
  border: 1px solid #e3eae5;
  border-radius: 10px;
  color: #1b6f71 !important;
  background: #fff;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.ticket-notification__trigger.nav-link::after {
  display: none;
}

.ticket-notification__trigger.nav-link:hover {
  border-color: #c7ddd1;
  background: #f5faf6;
}

.ticket-notification__trigger .nc-bell-55 {
  color: #1b6f71;
  font-size: 17px;
}

.ticket-notification__trigger-label {
  color: #526d7a;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.ticket-notification__chevron {
  color: #87979b;
  font-size: 10px;
  transition: transform 0.15s ease;
}

.ticket-notification__trigger[aria-expanded="true"] .ticket-notification__chevron {
  transform: rotate(180deg);
}

.ticket-notification__trigger .el-badge__content {
  top: 7px;
  right: 7px;
  border: 2px solid #fff;
  background: #d86a54;
  box-shadow: 0 2px 5px rgba(104, 45, 33, 0.18);
}

.ticket-notification .dropdown-menu {
  width: min(370px, calc(100vw - 24px));
  max-height: 440px;
  overflow: auto;
  padding: 7px;
  border: 1px solid #e1e9e4;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 14px 36px rgba(24, 48, 61, 0.16);
}

.ticket-notification__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 11px;
  border-bottom: 1px solid #e9efeb;
  list-style: none;
  background: #f8faf8;
}

.ticket-notification__head > div {
  display: grid;
  gap: 2px;
}

.ticket-notification__eyebrow {
  color: #7c8e91;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.9px;
}

.ticket-notification__head strong {
  color: #18394d;
  font-size: 13px;
  font-weight: 700;
}

.ticket-notification__count {
  color: #6b8388;
  font-size: 9px;
  font-weight: 600;
}

.ticket-notification__entry.dropdown-item {
  display: block;
  width: 100%;
  overflow: hidden;
  margin: 5px 0 0;
  padding: 10px 11px;
  border: 1px solid #edf1ee;
  border-radius: 8px;
  color: #405c68;
  white-space: normal;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.ticket-notification__entry.dropdown-item:hover {
  border-color: #d7e5dc;
  background: #f4f8f5;
}

.ticket-notification__entry.unseen {
  border-left: 3px solid #1b6f71;
  background: #f2f8f4 !important;
  color: #405c68 !important;
}

.ticket-notification__title {
  overflow: hidden;
  color: #234652;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
}

.ticket-notification__body {
  margin-top: 4px;
  color: #667c83;
  font-size: 11px;
  line-height: 1.45;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.ticket-notification__time {
  margin-top: 7px;
  color: #8b9a9c;
  font-size: 9px;
  font-style: italic;
}

.ticket-notification__clear.dropdown-item {
  padding: 7px 10px 3px;
  text-align: right;
}

.ticket-notification__clear .el-button {
  padding: 4px 2px;
  color: #1b6f71;
  font-size: 10px;
  font-weight: 700;
}

.ticket-notification__empty.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 7px;
  padding: 15px 11px;
  border: 1px solid #edf1ee;
  border-radius: 8px;
  color: #49636c;
  white-space: normal;
}

.ticket-notification__empty-icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  border: 1px solid #e1eae4;
  border-radius: 9px;
  color: #72908d;
  background: #f4f8f5;
}

.ticket-notification__empty > span:last-child {
  display: grid;
  gap: 3px;
}

.ticket-notification__empty strong {
  color: #405d68;
  font-size: 11px;
}

.ticket-notification__empty small {
  color: #89989b;
  font-size: 9px;
}

.ticket-notification .dropdown-item {
  cursor: pointer;
}

@media (max-width: 520px) {
  .ticket-notification .dropdown-menu {
    position: fixed;
    top: 72px;
    right: 12px;
    left: auto;
    width: calc(100vw - 24px);
  }
}
</style>
